import '../../style/index.less';
import './index.less';
// style dependencies
import '../../radio/style';
import '../../checkbox/style';
import '../../dropdown/style';
import '../../spin/style';
import '../../pagination/style';
import '../../ripple/style';
import '../../menu/style';
import '../../icon/style';
import '../../button/style';
import '../../message/style';
import '../../input-number/style';
